import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { resetarSenha } from '../services/usuarios';
import './PortalCliente.css';

function PortalResetarSenha() {
  const navigate = useNavigate();
  const location = useLocation();
  const emailEnviado = location.state?.email || '';

  const [form, setForm] = useState({ token: '', senha: '', confirmarSenha: '' });
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (form.senha !== form.confirmarSenha) {
      setStatus('error');
      setMessage('As senhas não coincidem.');
      return;
    }

    setStatus('submitting');

    try {
      const data = await resetarSenha({
        token: form.token.trim(),
        novaSenha: form.senha,
      });
      const sucesso =
        (typeof data === 'string' && data) ||
        data?.message ||
        'Senha redefinida com sucesso.';
      setMessage(sucesso);
      setStatus('success');
      setTimeout(() => navigate('/portal'), 1800);
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Não foi possível redefinir a senha. Verifique o token.');
    }
  };

  return (
    <div className="portal-page">
      <div className="page-hero">
        <h1>Nova senha</h1>
        <p>
          {emailEnviado
            ? `Enviamos um token para ${emailEnviado}. Digite-o abaixo com a nova senha.`
            : 'Digite o token recebido por e-mail e a nova senha.'}
        </p>
      </div>

      <section className="section">
        <div className="container">
          <div className="portal-login-box">
            {status === 'success' ? (
              <div className="portal-success">
                <h2>Senha atualizada!</h2>
                <p>{message}</p>
                <Link to="/portal" className="btn btn-primary">
                  Ir para o login
                </Link>
              </div>
            ) : (
              <>
                <h2>Redefinir senha</h2>
                <p className="portal-subtitle">Use o token enviado no seu e-mail.</p>

                <form className="portal-login-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="reset-token">Token</label>
                    <input
                      type="text"
                      id="reset-token"
                      name="token"
                      value={form.token}
                      onChange={handleChange}
                      required
                      autoComplete="one-time-code"
                      placeholder="Cole o token do e-mail"
                      disabled={status === 'submitting'}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="reset-senha">Nova senha</label>
                    <div className="portal-password-wrap">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        id="reset-senha"
                        name="senha"
                        value={form.senha}
                        onChange={handleChange}
                        required
                        autoComplete="new-password"
                        placeholder="Nova senha"
                        disabled={status === 'submitting'}
                        minLength={6}
                      />
                      <button
                        type="button"
                        className="portal-toggle-password"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                      >
                        {showPassword ? 'Ocultar' : 'Mostrar'}
                      </button>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="reset-confirmar">Confirmar nova senha</label>
                    <div className="portal-password-wrap">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        id="reset-confirmar"
                        name="confirmarSenha"
                        value={form.confirmarSenha}
                        onChange={handleChange}
                        required
                        autoComplete="new-password"
                        placeholder="Repita a nova senha"
                        disabled={status === 'submitting'}
                        minLength={6}
                      />
                      <button
                        type="button"
                        className="portal-toggle-password"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                      >
                        {showPassword ? 'Ocultar' : 'Mostrar'}
                      </button>
                    </div>
                  </div>

                  {status === 'error' && (
                    <p className="form-error" role="alert">{message}</p>
                  )}

                  <button type="submit" className="btn btn-primary btn-large" disabled={status === 'submitting'}>
                    {status === 'submitting' ? 'Salvando...' : 'Salvar nova senha'}
                  </button>
                </form>

                <p className="portal-switch">
                  <Link to="/portal/esqueci-senha">Reenviar token</Link>
                  {' · '}
                  <Link to="/portal">Voltar ao login</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default PortalResetarSenha;
